import React, { Component } from 'react';
import DOMPurify from "dompurify";
import UtilService from "../../services/util.service";
import { SCRIPTS } from '../../constants/staticScripts';

const loggedInWelcomeComponent = ({firstTimeMultiple,message,messageTime,hide_logo,hideSelectAccountText,fromHistory}) => {
    let image_width = window.innerWidth * 0.3


    return(<div>
        {firstTimeMultiple && 
        <div id="welcome_multiple_div" style={{height:`${document.getElementById('chat_message_id').clientHeight - 20}px`,padding:'0 20px',position:'absolute',overflow:'hidden',bottom:0}}>
      <span className="" >
          <img id="welcome_multiple_image" src="assets/images/arya.png" style={{position:'absolute',width:'30vw',height:'auto',marginTop:'20px'}}/>
      </span>

            <ul  className="bubblesNew relateNew" >
                <ul>
                    <li>
                    <p 
                 dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message, {ALLOW_UNKNOWN_PROTOCOLS: true})}} />
                    <span className="time">{messageTime.time_in_format}</span>
                    </li>
                    { !hideSelectAccountText && 
                        <li style={{width:'90%'}}><p>Just choose a connection for which you want to talk about.</p>
                        <span className="time">{messageTime.time_in_format}</span>
                        </li>
                    }
                   

                </ul>
            </ul>

        </div>}
        {!firstTimeMultiple &&
            <div>
            <span className="arya new" style={{visibility:(hide_logo) ? 'hidden' : 'visible'}}>
            {/* <img src="assets/images/arya.png" /> */}
        </span>
    
        <ul  className="bubbles relate">
                <li>
                    <p 
                 dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message, {ALLOW_UNKNOWN_PROTOCOLS: true})}} />
                    <span className="time">{messageTime.time_in_format}</span>
                    </li>
                    { !hideSelectAccountText && 
                        <li style={{width:'90%',marginTop:'8px'}}><p>Just choose a connection for which you want to talk about.</p>
                        <span className="time">{messageTime.time_in_format}</span>
                        </li>
                    }
        </ul>
    
        </div>}
        </div>
    )
}


export default loggedInWelcomeComponent


// WEBPACK FOOTER //
// ./src/components/message-components/loggedInWelcome.component.js